"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

require("../styles/_details-tab.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function DetailsTab(_ref) {
  var getCurrentOutput = _ref.getCurrentOutput,
      videoName = _ref.videoName;
  var output = getCurrentOutput();
  var outputId = output.outputId,
      latestVersion = output.latestVersion,
      isMaster = output.isMaster,
      notes = output.notes;
  return (/*#__PURE__*/_react.default.createElement(_commonReact.HistoryTab, {
      resourceId: outputId
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "details-tab"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "details-tab__header"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "video",
      size: 20,
      color: "regent"
    }), /*#__PURE__*/_react.default.createElement("h3", null, "Video Details")), /*#__PURE__*/_react.default.createElement("div", {
      className: "details-tab__header"
    }, isMaster && /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      color: "goldenTainoi",
      name: "master"
    }), /*#__PURE__*/_react.default.createElement("p", null, (0, _getVideoOutputName.default)(output, videoName))), /*#__PURE__*/_react.default.createElement("p", null, "VERSION ".concat("".concat(latestVersion).padStart(2, '0'))), /*#__PURE__*/_react.default.createElement("p", {
      className: "details-tab__header__notes"
    }, notes), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("h3", null, "Video Activities")))
  );
}

var _default = (0, _react.memo)(DetailsTab);

exports.default = _default;